export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="24"
    width="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.743 17.127l-7.027-12.15A1.985 1.985 0 0012 4a1.996 1.996 0 00-1.715.978l-7.027 12.15a1.875 1.875 0 000 1.897A1.952 1.952 0 004.974 20h14.053a1.964 1.964 0 001.714-.975 1.875 1.875 0 00.002-1.898zM11.358 10.4A.639.639 0 0112 9.76a.644.644 0 01.643.64v3.2a.638.638 0 01-.643.64.644.644 0 01-.642-.64v-3.2zM12 17.44a.967.967 0 01-.89-.593.956.956 0 01.702-1.309.968.968 0 01.99.409.957.957 0 01-.12 1.212.966.966 0 01-.682.28z"
      fill="currentColor"
    />
  </svg>
);
